import React from 'react';

import { colors } from 'settings/theme';
import ImageThumbnail from 'components/media/ImageThumbnail';
import DeleteIcon from 'components/icons/DeleteIcon';

class ImagesDisplay extends React.Component{
    render(){
        const {
            uploadRefs,
            isReadOnly,
            handleDelete,
        } = this.props;

        return(
            <div>
                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'flex-start',
                            overflow: 'auto',

                            marginBottom: 20,
                        }}
                    >
                        {Object.keys(uploadRefs).map((uploadId, index) => (
                            <div
                                key={uploadId}                                
                                style={{
                                    position: 'relative',
                                    marginTop: 15,
                                    marginRight: 15 + 20, // 15px to make room for the delete icon, 20 as spacing between thumbnails
                                }}
                            >
                            {!isReadOnly &&
                                <div
                                    style={{
                                        position: 'absolute',
                                        top: -15,
                                        right: -15,
                                    }}
                                    onClick={()=> handleDelete(uploadId)}
                                    
                                >
                                    <DeleteIcon
                                        radius={15}
                                        hoverFill={colors.danger}
                                        style={{
                                            cursor: 'pointer',
                                        }}
                                    />
                                </div>
                            }   
                                <ImageThumbnail
                                    src={uploadRefs[uploadId]}
                                    alt="Uploaded file"
                                    height={100}
                                    width={100}
                                />
                            </div>
                        ))}
                    </div>
            </div>
        );
    }
}

export default ImagesDisplay;


// WEBPACK FOOTER //
// ./src/components/ImagesDisplay.js